module.exports = __webpack_public_path__ + "img/l2.89edaf12.png";